var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"side-nav-item",on:{"click":function($event){return _vm.$emit('click')}}},[_c('div',{staticClass:"icon"},[_vm._t("icon")],2),_c('div',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.title)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }